export default __webpack_public_path__ + "static/media/prescription-en.1101cf9e.svg";